import * as React from 'react';

import * as styles from './styles.css';

interface IOfferHeaderProps {
  price: string;
}

export const OfferHeader: React.FC<IOfferHeaderProps> = ({ price }) => {
  return <div className={styles['price']}>{price}</div>;
};
